import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=5b969866&"
import script from "./ClientSelect.vue?vue&type=script&lang=ts&"
export * from "./ClientSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports